module.exports = __webpack_public_path__ + "static/img/pc.1497fbb0.png";